import Vue from "vue";
import "./bootstrap";

import { sync } from "vuex-router-sync";
import router from "./router";
import store from "./store";

sync(store, router);

import VueGtag from "vue-gtag";

Vue.use(
  VueGtag,
  {
    config: { id: "UA-156013749-1" },
    disableScriptLoad: true
  },
  router
);

import VueSocketio from "vue-socket.io-extended";
import appSocket from "@/setup/io";

Vue.use(VueSocketio, appSocket, { store });

import App from "./App.vue";

Vue.config.productionTip = false;

import "@/styles/main.scss";

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
